import * as angular from "angular"
import { observeResize } from "./resizeObserver"

export class TableHeaderSyncMgr {

    private _resizeObserver: Function

    private _tableHeaderElement: HTMLElement
    private _headerClientRect: ClientRect

    private _tableContentElement: HTMLElement
    private _contentClientRect: ClientRect

    private scrollHandler: (e: any) => void

    get headerClientRect(): ClientRect {
        return this._headerClientRect
    }

    get contentClientRect(): ClientRect {
        return this._contentClientRect
    }

    constructor() {

        this.scrollHandler = (e) => {
            var left = this._tableContentElement.scrollLeft
            this._tableHeaderElement.scrollLeft = left
        }

    }

    public dispose() {

        this._headerClientRect = undefined
        this._contentClientRect = undefined

        if (this._resizeObserver) {
            this._resizeObserver()
            this._resizeObserver = undefined
        }


        if (this._tableContentElement) {
            this._tableContentElement.removeEventListener("scroll", this.scrollHandler)
        }

    }

    public setup(rootElement: HTMLElement, contentSelector: string, headerSelector: string) {

        this.dispose()

        if (rootElement) {

            this._tableHeaderElement = <HTMLElement>rootElement.querySelector(headerSelector)
            this._tableContentElement = <HTMLElement>rootElement.querySelector(contentSelector)

            if (this._tableHeaderElement && this._tableContentElement) {

                this._resizeObserver = observeResize(this._tableContentElement, () => this.updateLayout(), 500)
                this._tableContentElement.addEventListener("scroll", this.scrollHandler)

                this.updateLayout()

            }

        }

    }

    private updateLayout() {

        this._headerClientRect = this._tableHeaderElement.getBoundingClientRect()
        this._contentClientRect = this._tableContentElement.getBoundingClientRect()

        let width = this._contentClientRect.width

        angular.element(this._tableHeaderElement).css("width", width.toString() + "px")

    }



}
